import { useCallback, useState } from "react"
import type { FC, ReactElement } from "react"

import {
    Avatar,
    EAvatarSize,
    ETypographyFamily,
    ETypographySize,
    ETypographyTag,
    ETypographyWeight,
    Typography
} from "@/3514/components"
import {
    EWindowCustomEvent,
    type TScreenBreakpoints,
    type TWindowCustomEventPayloadMap,
    useScreenBreakpoints,
    useWindowCustomEventListener
} from "@/3514/hooks"
import { EUserRole } from "@/3514/types"

import styles from "./header-meta.styles"
import { HeaderMetaView } from "./header-meta.view"

type _TProps = { isVisible: boolean }
const HeaderMetaAssistant: FC<_TProps> = ({ isVisible }: _TProps): ReactElement => {
    const [metaState, setMetaState] = useState({
        firstName: "John",
        lastName: "Doe",
        photo: null
    })

    const breakpoints: TScreenBreakpoints = useScreenBreakpoints()

    const customEventListener: (
        e: CustomEvent<TWindowCustomEventPayloadMap[EWindowCustomEvent.AssistantMeta]>
    ) => void = useCallback((e: CustomEvent<TWindowCustomEventPayloadMap[EWindowCustomEvent.AssistantMeta]>): void => {
        setMetaState(e.detail)
    }, [])

    useWindowCustomEventListener(EWindowCustomEvent.AssistantMeta, customEventListener)

    return (
        <HeaderMetaView role={EUserRole.Assistant} motionKey="user-info" isVisible={isVisible}>
            <Avatar
                url={metaState.photo}
                userData={{ firstName: metaState.firstName, lastName: metaState.lastName }}
                size={EAvatarSize._40}
                isLettered
                className={styles[EUserRole.Assistant].loadingValue({
                    isBlurred: metaState.firstName === "John" && metaState.lastName === "Doe",
                    intensity: 3
                })}
            />

            <Typography
                text={`${metaState.firstName} ${metaState.lastName}`}
                family={ETypographyFamily.DmSerif}
                tag={ETypographyTag.Heading1}
                weight={ETypographyWeight.Medium}
                size={breakpoints.xs || breakpoints.sm ? ETypographySize.Heading2 : ETypographySize.Heading1}
                className={styles[EUserRole.Assistant].loadingValue({
                    isBlurred: metaState.firstName === "John" && metaState.lastName === "Doe",
                    intensity: 5
                })}
            />
        </HeaderMetaView>
    )
}

HeaderMetaAssistant.displayName = "HeaderMetaAssistant"

export { HeaderMetaAssistant }
